import React from 'react';

export const CarrotIconUp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.46094 4.98438C7.74219 4.67969 8.23438 4.67969 8.51562 4.98438L13.0156 9.48438C13.3203 9.76562 13.3203 10.2578 13.0156 10.5391C12.7344 10.8438 12.2422 10.8438 11.9609 10.5391L8 6.57812L4.01562 10.5391C3.73438 10.8438 3.24219 10.8438 2.96094 10.5391C2.65625 10.2578 2.65625 9.76562 2.96094 9.48438L7.46094 4.98438Z"
        fill="currentColor"
      />
    </svg>
  );
};
